// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__lrhej","mainContent":"Layout_mainContent__H9L-8","contentBody":"Layout_contentBody__pma02"};